import { useEffect } from 'react';
import { useFormikContext } from 'formik';

const ValidationErrors = ({ className, locale, separator = ', ' }) => {
  const { errors, submitCount, validateForm } = useFormikContext();

  useEffect(() => {
    if (submitCount > 0) {
      validateForm().catch(() => {});
    }
  }, [locale]);

  const message = Object.values(errors)
    .filter((v) => v != null && typeof v == 'string' && v.trim().length > 0)
    .map((v) => v.trim())
    .join(separator);
  if (message.length === 0) return undefined;
  return <div className={className}>{message}</div>;
};
export default ValidationErrors;
